export const formatClassName = (
  className: string,
  classNameProp: string | undefined,
) => [className, classNameProp].join(' ');
